module.exports = __webpack_public_path__ + "static/media/AUTONOMIA_APRENDIZAJE.ca5eb370.png";